import IPPriceDisplay from './IPPriceDisplay'

export default IPPriceDisplay
